import { render, staticRenderFns } from "./PeerEvaluation.vue?vue&type=template&id=408f129b&"
import script from "./PeerEvaluation.vue?vue&type=script&lang=js&"
export * from "./PeerEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports